/**
 * Copyright (c) 2017-present, Tomaruba, Inc.
 * All rights reserved.
 *
 */
import { ReduceStore } from 'flux/utils'
import AppDispatcher from '../../core/AppDispatcher'
import { Record } from 'immutable'
import CheckInEvent from '../../event/CheckInEvent'
import PaginationParams from '../PagenationParams'

const CheckInPaginationState = Record(PaginationParams)

class CheckInPaginationStore extends ReduceStore {
  constructor() {
    super(AppDispatcher)
  }

  getInitialState() {
    return new CheckInPaginationState()
  }

  reduce(state, action) {
    const payload = action.payload

    switch (action.type) {
      case CheckInEvent.initialize:
        return state.clear()
      case CheckInEvent.fetchAll:
        return state.merge({
          page: payload.pagination.page,
          per_page: payload.pagination.per_page,
          total: payload.pagination.total
        })
    }

    return state
  }
}

export default new CheckInPaginationStore()
